import {
    ChangeDetectorRef,
    Component,
    forwardRef,
    OnInit,
    Input,
    ViewChild,
    OnDestroy,
} from "@angular/core"
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms"
import { EditorComponent as TinyMceEditorComponent } from "@tinymce/tinymce-angular"
import { EduComponent } from "../../utils/eduComponent"

@Component({
    selector: "app-editor",
    templateUrl: "./editor.component.html",
    styleUrls: ["./editor.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditorComponent),
            multi: true,
        },
    ],
})
export class EditorComponent
    extends EduComponent
    implements ControlValueAccessor, OnInit, OnDestroy {
    public value: string
    @ViewChild(TinyMceEditorComponent)
    public editor: TinyMceEditorComponent
    public render: boolean = true
    public settings: Record<string, any>
    @Input()
    public set init(init: Record<string, any>) {
        this.settings = Object.assign(this.defaultInit, init)
    }

    public defaultInit: Record<string, any> = {
        skin: "oxide",
        menubar: false,
        height: 300,
        plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount",
        ],
        toolbar:
            "undo redo | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | help",
    }

    public editorFormControl: FormControl = new FormControl()
    private onChange: (_: any) => {}
    private onTouch: () => {}

    constructor(private changeDetectorRef: ChangeDetectorRef) {
        super()
    }

    public ngOnInit() {
        this.addSub(
            this.editorFormControl.valueChanges.subscribe((value) => {
                this.onChange(value)
                this.onTouch()
            })
        )
    }

    public emitChanges() {
        this.onChange(this.value)
    }

    public writeValue(val: any): void {
        this.editorFormControl.setValue(val, {
            emitEvent: false,
        })
    }

    public registerOnChange(fn: any): void {
        this.onChange = fn
    }

    public registerOnTouched(fn: any): void {
        this.onTouch = fn
    }

    public setDisabledState(fn: any) {}

    /** We need this because whenever we drag and drop
     *  tinymce editor it breaks, so we need a mechanism to refresh it.
     */
    public reinit() {
        this.render = false
        this.changeDetectorRef.detectChanges()
        this.render = true
        this.changeDetectorRef.detectChanges()
    }
}
